module.exports = __webpack_public_path__ + "static/media/ironICE.51f06876.svg";